import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Section, Tile } from "@/growth/components/_ui";

export default function OverviewTab({ summary, onGoto }) {
  const brandStatus = summary?.brand_status || "not_started";
  const brandTone = brandStatus === "approved" ? "emerald" : "amber";
  return (
    <div>
      <Section title="Growth Center Overview" subtitle="Where your business stands right now — one source of truth, human approval on every step.">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="gc-overview-tiles">
          <Tile label="Brand Brain" value={brandStatus === "approved" ? `v${summary?.approved_brand_version || 1}` : "Draft"} hint={brandStatus === "approved" ? "Approved" : "Awaiting approval"} tone={brandTone} />
          <Tile label="Growth Score" value={summary?.latest_audit_score ?? "—"} hint={summary?.latest_audit_id ? "Latest audit" : "Run your first audit"} tone="indigo" />
          <Tile label="Pending Actions" value={summary?.recommendations?.pending ?? 0} hint={`${summary?.recommendations?.approved ?? 0} approved`} tone="amber" />
          <Tile label="AI Visibility" value={summary?.visibility?.observed_answers ?? 0} hint={`${summary?.visibility?.approved_prompts ?? 0} approved prompts`} tone="sky" />
        </div>
      </Section>

      <Section title="The Loop" subtitle="Observe → Understand → Explain → Recommend → Create → Approve → Measure → Learn.">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {[
            { k: "brand", label: "1 · Approve Brand", body: "Own the source of truth: identity, voice, claims.", cta: "Open Brand Brain", tab: "brand" },
            { k: "audit", label: "2 · Run Audit", body: "One workspace for website, SEO, local, AI signals.", cta: "Run audit", tab: "audit" },
            { k: "vis", label: "3 · Measure AI Visibility", body: "Are you cited when buyers ask? Get evidence.", cta: "Set up prompts", tab: "visibility" },
            { k: "creative", label: "4 · Make Assets", body: "Three concept variations. Hypothesis-driven, on-brand.", cta: "Draft a brief", tab: "creative" },
          ].map((s) => (
            <Card key={s.k} className="p-5 border border-slate-200 rounded-2xl hover:shadow-md transition-shadow">
              <div className="text-[11px] font-bold uppercase tracking-widest text-emerald-700">{s.label}</div>
              <div className="text-sm text-slate-600 mt-2 min-h-[48px]">{s.body}</div>
              <Button size="sm" variant="outline" className="mt-3 rounded-full" onClick={() => onGoto(s.tab)} data-testid={`gc-overview-cta-${s.k}`}>
                {s.cta} <span className="ml-1">→</span>
              </Button>
            </Card>
          ))}
        </div>
      </Section>
    </div>
  );
}
